<template>
  <div class="homemain TopHeadder">
      <!-- <swipe class="my-swipe" :auto='4000'>
          <swipe-item>
            <img src="../assets/image/home-banner1.jpg"/>
          </swipe-item>
          <swipe-item>
            <img src="../assets/image/home-banner2.jpg"/>
          </swipe-item>
          <swipe-item>
            <img src="../assets/image/home-banner3.jpg"/>
          </swipe-item>
          <swipe-item>
            <img src="../assets/image/home-banner4.jpg"/>
          </swipe-item> 
          <swipe-item>
            <img src="../assets/image/home-banner5.jpg"/>
          </swipe-item>
         
		 </swipe>-->
      <div class="bannerBox">
          <img src="../assets/image/home_banner.png" />
          <div class="bannerTitle">
             <h3>AI智能服务营销一体化解决方案专家</h3>
             <p>AI赋能企业营销、客服管理、服务运营、经营决策等关键环节，构建</p>
             <p>一体化智能解决方案，让企业增长变得简单、高效</p>
          </div>
      </div>
     <div class="home_item1 PublicPadding">
         <h4 class="title">核心产品</h4>
         <!-- <h5 class="titleh5">开启智能人机交互时代</h5> -->
         <ul class="clear">

             <router-link to="/product/marketing" tag="li" activeClass="active" exact>
                 <i><img src="../assets/image/home1_1.png"/></i>
                 <p>智能外呼机器人iCall</p>
             </router-link>
             <router-link to="/product/IVR" tag="li" activeClass="active" exact>
                 <i><img src="../assets/image/home1_2.png"/></i>
                 <p>电销外呼系统—易营销</p>
             </router-link>
             <router-link to="/product/enterPrise" tag="li" activeClass="active" exact>
                   <i><img src="../assets/image/home1_3.png"/></i>
                 <p>企业客服系统 iService</p>
             </router-link>
             <router-link to="/product/bigData" tag="li" activeClass="active" exact>
                 <i><img src="../assets/image/home1_4.png"/></i>
                 <p>大数据中台 BDOS</p>
             </router-link>
             <router-link to="/product/customerService" tag="li" activeClass="active" exact>
                  <i><img src="../assets/image/home1_5.png"/></i>
                 <p>语音中间件平台WiDilink</p>
             </router-link>
             <router-link to="/product/proHotline" tag="li" activeClass="active" exact>
                 <i><img src="../assets/image/home1_6.png"/></i>
                 <p>心理援助热线系统P9</p>
             </router-link>
            
         </ul>
     </div>
     <div class="home_item2 PublicPadding colorbg">
        <h4 class="title">助力企业，构建更美好的营销服务体验</h4>
        <ul class="clear">
            <li>
                <i><img src="../assets/image/home2-1.png"/></i>
                <h3>16年行业经验积累</h3>
                <p>16年通讯及智能营销服务领域研发背景，5000+企业客户成功交付经验</p>
            </li>
             <li>
                <i><img src="../assets/image/home2-2.png"/></i>
                <h3>专业技术研发团队</h3>
                <p>浙江大学博导领衔的核心研发团 队，成熟的人工智能语音处理技术，多项发明专利及软著，用专业见证实力</p>
            </li>
             <li>
                <i><img src="../assets/image/home2-3.png"/></i>
                <h3>多行业细分解决方案</h3>
                <p>针对各行业痛点不断深挖，提供个性化产品服务定制，更贴近真实场景</p>
            </li>
             <li>
                <i><img src="../assets/image/home2-4.png"/></i>
                <h3>标杆级客户服务体验</h3>
                <p>高效客户服务团队，提供个性化专业指导，保证24h/7的客户成功服务</p>
            </li>
        </ul> 
     </div>
     <div class="home_item3">
        <h4 class="title">大数据+AI</h4>
        <h5 class="tith5">让服务营销简单、智能、高效</h5>
        <ul class="clear">
            <li>
                <i>
                    <img src="../assets/image/home3_up.png" />
                    <span>12倍</span>
                </i>
                <h3>时间利用率</h3>
                <p>提升12倍以上</p>
            </li>
            <li>
                <i>
                    <img src="../assets/image/home3_down.png" />
                    <span>72%</span>
                </i>
                <h3>人力成本</h3>
                <p>节约72%以上</p>
            </li>
            <li>
                <i>
                    <img src="../assets/image/home3_up.png" />
                    <span>148%</span>
                </i>
                <h3>销售业绩</h3>
                <p>提升148%以上</p>
            </li>
            <li class="h_li4">
                <i>
                    <img src="../assets/image/home3_up.png" />
                    <span>186%</span>
                </i>
                <h3>边际收益</h3>
                <p>提升186%以上</p>
            </li>
            <li class="h_li5">
                <i>
                    <img src="../assets/image/home3_up.png" />
                    <span>40%</span>
                </i>
                <h3>客户满意度</h3>
                <p>提升40%以上</p>
            </li>
        </ul>

     </div>

      <!--客户案例-->
      <div class="home_item4 PublicPadding">
          <h4 class="title">10000+企业的信赖选择</h4>
          <h5 class="titleh5">选择小语智能，开启高效、智能的客服营销新时代</h5>
          <div class="logosBox">
              <img src="../assets/image/home3_logo.png" />
          </div>
      </div>
      <div>
          


      </div>
     <Popup v-show="$store.state.isshow"></Popup>
  </div>
</template>

<script>
import "vue-swipe/dist/vue-swipe.css"; //css 模块化 导入
import { Swipe, SwipeItem } from 'vue-swipe';
import Popup from "@/components/popup"
export default {
  name: 'homemain',

  data () {
    return {
        current:1,
        
    }
  },
 components:{
  	swipe:Swipe,
  	"swipe-item":SwipeItem,
    Popup
  },
 methods:{
   
    popup(){
       this.$store.commit("openPop",{isopen:true,type:1})
    },
    clickActive(num){
       this.current=num
    },

  }
}
</script>


<style scoped>
.audioBox{display: none;}
.my-swipe{
  height:4rem; 
}
.my-swipe img{
  width:100%;
  height:4rem;
}

.home_item1 ul li{
   float: left;
   width: 1.4rem;
   margin: 0.72rem 0.55rem 0 0.55rem;
}
.home_item1 ul li i{
    display: block;
    width: 0.97rem;
    height: 0.83rem;
    margin: 0 auto;
    margin-bottom: 0.28rem;
}
.home_item1 ul li i img{
    display: block;
    width: 0.97rem;
    height: 0.83rem;
}
.home_item1 ul li p{
    font-size: 0.22rem;
    color: #333;
    line-height: 0.3rem;
    text-align: center;
}
.home_item2 ul{
  margin-top: 0.4rem;
}
.home_item2 ul li{
    float: left;
    width: 3.2rem;
    height: 4.3rem;
    box-shadow: 0px 0px 0.05rem 0.01rem rgba(0, 0, 0, 0.17);
    margin: 0.2rem 0.2rem 0.2rem 0.3rem;
    background: #fff;
}
.home_item2 ul li i{
    display: block;
    width: 1.13rem;
    height: 1.27rem;
    margin: 0 auto;
    margin-top: 0.44rem;
}
.home_item2 ul li i img{
    display: block;
    width: 1.13rem;
    height: 1.27rem;
}
.home_item2 ul li h3{
    font-size: 0.24rem;
    color: #333;
    font-weight: 400;
    text-align: center;
    margin: 0.15rem 0 0.37rem 0;
}
.home_item2 ul li p{
    width: 2.8rem;
    font-size: 0.2rem;
    color: #999;
    line-height: 0.36rem;
    text-align: center;
    margin: 0 auto;
}
.home_item3{
   background: url("../assets/image/home3_bg.png") no-repeat;
   background-size:100% 100%;
   height: 8.4rem;
}
.home_item3 .title{
    font-size: 0.36rem;
    font-weight: 400;
    color: #FFFFFF;
    padding: 0.74rem 0 0.2rem 0;
}
.home_item3 .tith5{
    font-size: 0.2rem;
    font-weight: 400;
    color: #FFFFFF;
    opacity: 0.4;
    text-align: center;
}
.home_item3 ul{
    overflow: hidden;
    padding-left:0.1rem;
}
.home_item3 ul li{
    float: left;
    width: 1.52rem;
    margin:0.5rem 0.47rem 0 0.47rem;
}
.home_item3 ul li i{
    display: block;
    width:1.42rem;
    height: 1.42rem;
    background: url("../assets/image/home3_bg2.png") no-repeat;
     background-size:100% 100%;
}
.home_item3 ul li.h_li4{
    margin-left:1.6rem;
}
.home_item3 ul li.h_li5{
    margin-left:0.9rem;
}
.home_item3 ul li i img{
    display: block;
    width: 0.15rem;
    height: 0.22rem;
    margin: 0 auto;
    padding-top:0.22rem;
}
.home_item3 ul li i span{
    display: block;
    font-size: 0.28rem;
    color: #33CAF2;
    text-align: center;
    margin-top: 0.2rem;
}
.home_item3 ul li h3{
    font-size: 0.18rem;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    margin: 0.4rem 0 0.18rem 0;
}
.home_item3 ul li p{
    font-size: 0.14rem;
    color: #FFFFFF;
    text-align: center;
    opacity: 0.4;
}
.logosBox{
    display: block;
    width: 6.92rem;
    height: 5.2rem;
    margin: 0 auto; 
    margin-top:0.6rem;
}
.logosBox img{
    display: block;
    width: 6.92rem;
    height: 5.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/homemain.vue